import { render, staticRenderFns } from "./userManagementedit.vue?vue&type=template&id=4f84686a&scoped=true&"
import script from "./userManagementedit.vue?vue&type=script&lang=js&"
export * from "./userManagementedit.vue?vue&type=script&lang=js&"
import style0 from "./userManagementedit.vue?vue&type=style&index=0&id=4f84686a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84686a",
  null
  
)

export default component.exports